import { withCameraOrbiter } from './with_camera_orbiter'

function entitiesAreVisible (cesiumViewer) {
  return cesiumViewer.entities.values.some(e => e.isShowing)
}

// Overrides the home button to zoom to all entities.
// Adds a zoomToEntities function to the controller to allow other code to call it.
export const useZoomToEntities = (controller, { cesiumViewer }) => {
  // Zoom in at a slight angle
  const zoomToEntities = () => {
    if (!entitiesAreVisible(cesiumViewer)) {
      cesiumViewer.camera.flyHome(2)
      return Promise.resolve()
    }

    if (controller.zoomOrbiter && controller.zoomOrbiter.isEnabled()) {
      // Zoom in at a slight angle (for orbiting)
      return cesiumViewer.zoomTo(cesiumViewer.entities, new Cesium.HeadingPitchRange(0.0, -Cesium.Math.PI_OVER_SIX, 1000))
    } else {
      // Zoom in directly overhead
      return cesiumViewer.zoomTo(cesiumViewer.entities, new Cesium.HeadingPitchRange(0.0, Cesium.Math.toRadians(-90.0), 1000))
    }
  }

  // Add a function to zoom to all entities
  const homeOverride = (e) => {
    e.cancel = true

    // Toggle the zoom orbiter on/off
    if (controller.zoomOrbiter && controller.zoomOrbiter.isEnabled()) {
      controller.zoomOrbiter.disable()
    } else if (controller.zoomOrbiter) {
      controller.zoomOrbiter.enable()
    }

    // Zoom to the Entities
    zoomToEntities()
  }

  // Add the override to the home button
  cesiumViewer.homeButton.viewModel.command.beforeExecute.addEventListener(homeOverride)

  const controllerDisconnect = controller.disconnect.bind(controller)
  Object.assign(controller, {
    disconnect () {
      // Remove the override
      cesiumViewer.homeButton.viewModel.command.beforeExecute.removeEventListener(homeOverride)

      // Disconnect the Controller
      controllerDisconnect()
    },
    zoomToEntities,
    zoomToAndOrbitCoordinates ({ latitude, longitude }) {
      // Create the zoom orbiter if it doesn't exist
      if (!controller.zoomOrbiter) {
        controller.zoomOrbiter = withCameraOrbiter(controller, { cesiumViewer })
      }

      // Enable the zoom orbiter
      controller.zoomOrbiter.enable()

      // Zoom to the Entities and start orbiting
      zoomToEntities().then(() => {
        controller.zoomOrbiter.setTarget({ latitude, longitude })
      })
    }
  })
}
